import styles from './newFooter.module.scss'

export const cards = [
  { name: 'visa', src: '/visa.png' },
  { name: 'american', src: '/american.png' },
  { name: 'mastercard', src: '/mastercard.png' },
  { name: 'discover', src: '/discover.png' },
  { name: 'apple-pay', src: '/apple-pay.png' },
  { name: 'google-pay', src: '/google-pay.png' },
  { name: 'amazon-pay', src: '/amazon-pay.png' },
]

export const social = [
  {
    name: 'facebook',
    src: 'https://www.facebook.com/mawoopets',
    label: 'Circular Facebook logo in black',
    className: styles.iconFb,
  },
  {
    name: 'instagram',
    src: 'https://www.instagram.com/mawoopets/',
    label: 'Circular Instagram logo in black',
    className: styles.iconInstagram,
  },
  {
    name: 'tiktok',
    src: 'https://www.tiktok.com/discover/mawoo-pets',
    label: 'Circular Tiktok logo in black',
    className: styles.iconTiktok,
  },
  {
    name: 'pinterest',
    src: 'https://www.pinterest.com/mawoopets/_created/',
    label: 'Circular Pinterest logo in black',
    className: styles.iconPinterest,
  },
]

export const routes = {
  puppies: [
    { title: 'Search', slug: '/search' },
    { title: 'Explore all puppies', slug: '/puppies-for-sale' },
    { title: 'Explore by breed', slug: '/puppies-for-sale#breed' },
    { title: 'Explore by state', slug: '/puppies-for-sale#location' },
    { title: 'Explore by category', slug: '/puppies-for-sale#category' },
  ],
  mawooPets: [
    { title: 'Customer Reviews', slug: '/reviews' },
    { title: 'Puppy Travel', slug: '/puppy-travel' },
    { title: 'Blog', slug: '/blog' },
    { title: 'Our Mission', slug: '/mission' },
    { title: 'For Breeders', slug: '/join-as-breeder' },
  ],
  support: [
    { title: 'FAQs', slug: '/faq/customer' },
    { title: 'Contact Us', slug: '/contact' },
    { title: 'Privacy Policy', slug: '/policy' },
    { title: 'Terms & Conditions', slug: '/tos' },
    { title: 'Refund Policy', slug: '/refund-policy' },
  ],
}
